import { render, staticRenderFns } from "./ResizableDataTable.vue?vue&type=template&id=7933027f&scoped=true&lang=html&"
import script from "./ResizableDataTable.vue?vue&type=script&lang=js&"
export * from "./ResizableDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ResizableDataTable.vue?vue&type=style&index=0&id=7933027f&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7933027f",
  null
  
)

export default component.exports